module.exports = __webpack_public_path__ + "static/img/icon-search.2079e5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toutiao/icon-search.png
// module id = fOgK
// module chunks = 156